import script from "./static-content-wrapper-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./static-content-wrapper-ly.vue?vue&type=script&setup=true&lang=js"

import "./static-content-wrapper-ly.vue?vue&type=style&index=0&id=20249208&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20249208"]])

export default __exports__